import type { PostFields } from '@tribeplatform/gql-client/graphql'
import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Post,
  MutationMovePostArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getFeedKey } from '../../utils/keys/feed.keys.js'
import { getPostKey, getPostsKey } from '../../utils/keys/post.key.js'

import { pinnedPostsFilter } from './filters.js'

export const useMovePost = (options?: {
  fields?: PostFields
  useMutationOptions?: UseMutationOptions<
    Post,
    ClientError,
    MutationMovePostArgs
  >
}) => {
  const { useMutationOptions, fields } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Post, ClientError, MutationMovePostArgs>(
    variables => client.posts.movePost(variables, fields),
    {
      onSettled: (data, error, variables) => {
        const postKey = getPostKey({ variables: { id: variables.id } })
        queryClient.invalidateQueries(postKey)

        const postsKey = getPostsKey()
        queryClient.invalidateQueries(postsKey)
        queryClient.invalidateQueries({ ...pinnedPostsFilter, type: 'active' })

        const feedKey = getFeedKey()
        queryClient.invalidateQueries(feedKey)
      },
      ...useMutationOptions,
    },
  )
}
